/** Display formatting helpers (money, megapixels, dimensions). */

const AUD = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** `0.7` -> `$0.70`. */
export function formatMoney(dollars: number): string {
  return AUD.format(dollars);
}

/** Whole megapixels for a caption, e.g. 6000×4000 -> 24. */
export function megapixels(width: number, height: number): number {
  return Math.round((width * height) / 1_000_000);
}

/** `24 MP`. */
export function formatMp(width: number, height: number): string {
  return `${megapixels(width, height)} MP`;
}

/** `6000×4000`. */
export function formatDims(width: number, height: number): string {
  return `${width}×${height}`;
}

/** `24 MP · 6000×4000` — the card caption from the handoff. */
export function formatMpDims(width: number, height: number): string {
  return `${formatMp(width, height)} · ${formatDims(width, height)}`;
}

/** Human file size, e.g. `4.2 MB`. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let n = bytes / 1024;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n >= 10 ? 0 : 1)} ${units[i]}`;
}
